import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { StylesPieChartLable, bgColor , borderColor } from "../styled";

ChartJS.register(ArcElement, Tooltip, Legend);

const labels = [
  "A-EYE KIDS CHILDREN INSTITUTE",
  "Academy of English",
  "Future English",
  "Melbourne College Hairdressing Beauty & Natural Medicine",
  "Southern English College",
  "Hawthorn-Melbourne",
  "Oak Leaf Education Institute",
  "Generation Australia",
  "Charlton Brown & NIET Group",
  "Acacia Institute",
];

export const data = {
  datasets: [
    {
      label: "# of Votes",
      data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
      backgroundColor: bgColor,
      borderColor: borderColor,
      borderWidth: 1,
    },
  ],
};

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "right",
    },
    // datalabels: {
    //   formatter: (value) => {
    //     return value + "%";
    //   },
    // },
  },
};

const PieChartLabel = ({ bgColor, borderColor, label }) => {
  return (
    <StylesPieChartLable>
      <div
        className="tag"
        style={{
          backgroundColor: bgColor,
          border: `1px solid ${borderColor}`,
          height: "12px",
          width: "40px",
        }}
      />
      <span className="text-sm">{label}</span>
    </StylesPieChartLable>
  );
};

const StatisticsPieChart = () => {
  return (
    <div className="flex">
      <div style={{ width: "230px" }}>
        <Pie data={data} plugins={[ChartDataLabels]} options={options} />
      </div>
      <div className="flex flex-col justify-center">
        {bgColor?.map((color, index) => (
          <PieChartLabel
            bgColor={color}
            label={labels[index]}
            borderColor={borderColor[index]}
          />
        ))}
      </div>
    </div>
  );
};

export function userPie(input,item){
  if(input  && Object.keys(input).length > 0){
  let inputData = {}
  for (const key in input) {
    if (input[key][item] !== undefined) {
      inputData = input[key];
      break;
    }
  }
  const pieData = inputData[item]
  // console.log(pieData)
  let pieLbl,dataSet
  if(pieData && Object.keys(pieData).length > 0){
   pieLbl = Object.keys(pieData)
   dataSet = {datasets: [
      {
        label: item,
        data: Object.values(pieData),
        backgroundColor: bgColor,
        borderColor: borderColor,
        borderWidth: 1,
      },
    ]
  }
}else{
  dataSet = {datasets: [
    {
      label: item,
      data: [0],
      backgroundColor: bgColor,
      borderColor: borderColor,
      borderWidth: 1,
    },
  ]
}
  pieLbl = ['No Data']
}
  return (
    <div className="flex">
      <div style={{ width: "230px" }}>
        <Pie data={dataSet} plugins={[ChartDataLabels]} options={options} />
      </div>
      <div className="flex flex-col justify-center">
        {pieLbl?.map((color, index) => (
          <PieChartLabel
            bgColor={bgColor[index]}
            label={pieLbl[index]}
            borderColor={borderColor[index]}
          />
        ))}
      </div>
    </div>
  );
}else{
  StatisticsPieChart()
}
}

export default StatisticsPieChart;
